<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-等级管理-编辑等级
  -->
  <el-dialog
    title="编辑等级"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="600px"
  >
    <el-form size="small" :model="form" ref="form">
      <el-form-item
        label="等级名称"
        :label-width="formLabelWidth"
        prop="name"
        :rules="[{ required: true, message: ' ' }]"
      >
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="等级" :label-width="formLabelWidth">
        <el-input type="number" name="" id="" />
        <div>级别数字越大表示等级越高，等级级别不能相同。填写大于1的整数</div>
      </el-form-item>
      <el-form-item label="佣金" :label-width="formLabelWidth">
        <el-input type="number" name="" id="" />
        <div>等级佣金总和不能超过100%</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editGrade" :disabled="submit_loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import UserApi from "@/api/user.js";
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      dialogVisible: false,
      /*是否正在提交*/
      submit_loading: false
    };
  },
  props: ["open_edit", "form"],
  created() {
    this.form.open_money = this.form.open_money == 1 ? true : false;
    this.form.open_points = this.form.open_points == 1 ? true : false;
    this.form.open_invite = this.form.open_invite == 1 ? true : false;
    this.dialogVisible = this.open_edit;
  },
  methods: {
    /*修改用户*/
    editGrade() {
      let self = this;
      let params = this.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.submit_loading = true;
          if (params.is_default == 0) {
            params.open_money = params.open_money == true ? 1 : 0;
            params.open_points = params.open_points == true ? 1 : 0;
            params.open_invite = params.open_invite == true ? 1 : 0;
          } else {
            delete params.open_money;
            delete params.open_points;
            delete params.open_invite;
            delete params.upgrade_money;
            delete params.upgrade_points;
            delete params.upgrade_invite;
          }
          UserApi.editGrade(params, true)
            .then(data => {
              self.submit_loading = false;
              self.$message({
                message: "恭喜你，等级修改成功",
                type: "success"
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.submit_loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/promotion/user/grade/part/Edit.vue